import React, { useState } from 'react';
import { Route, Routes } from 'react-router-dom';
import SearchPage from '../Pages/SearchPage';
import ErrorPage from '../Pages/ErrorPage/';
import TeamPage from '../Pages/TeamPage';
import CommissionPage from '../Pages/CommissionPage';
import { PresentationMode } from '../Enums/PresentationMode';
import EmployerPage from '../Pages/EmployerPage/EmployerPage';
import AgentConversionPage from '../Pages/AgentConversionPage';
import SplitSalesPage from '../Pages/SplitSalesPage';

const AppRoutes = () => {
  const [errorCode, setError] = useState(null);

  if (errorCode) return <ErrorPage code={errorCode} setError={setError} />;
  else
    return (
      <Routes>
        <Route path="/" element={<SearchPage />} />
        <Route path="/team/*">
          <Route
            path="view/:codePrefix"
            element={<TeamPage presentationMode={PresentationMode.View} key="team-view" />}
          />
          <Route path="view/:codePrefix/:modal" element={<TeamPage presentationMode={PresentationMode.View} />} />
          <Route
            path="view/:codePrefix/:modal/:agentCode"
            element={<TeamPage presentationMode={PresentationMode.View} />}
          />
          <Route path="add/" element={<TeamPage presentationMode={PresentationMode.Add} key="team-add" />} />
        </Route>

        <Route path="/employer/*">
          <Route path="view/:employerId" element={<EmployerPage presentationMode={PresentationMode.View} />} />
          <Route path="add/" element={<EmployerPage presentationMode={PresentationMode.Add} />} />
        </Route>

        <Route path="/team/commission/:agentCode" element={<CommissionPage />} />

        <Route path="/salescodeconversions/" element={<AgentConversionPage setError={setError} />} />

        <Route path="/split/:policyVersion/:policyState/:agentCode" element={<SplitSalesPage />} />
      </Routes>
    );
};

export default AppRoutes;
